<template>
  <section class="relative z-10 py-16 md:py-[110px] text-center bg-[#9AB6DD] bg-repeat-y" :style="{backgroundImage: `url(${isMobile ? petMobileImg : petImg})`}">
    <div class="max-w-[1920px] p-4 md:px-[60px] lg:px-8 xl:px-[80px] 2xl:px-[120px] mx-auto py-[110px] space-y-[60px]">
      <div class="flex flex-col lg:flex-row justify-between items-center space-y-[32px] lg:space-x-[60px] xl:space-x-[120px]">
        <div class="text-left space-y-6">
          <h2 class="text-[22px] sm:text-[30px] md:text-[35px] xl:text-[40px]  font-bold text-black uppercase">{{ t('home.vision.vision') }}</h2>
          <h4 class="text-[18px] md:text-[22px] leading-[32px] text-light text-black">
            {{ t('home.vision.visionText') }}
          </h4>
        </div>
        <div class="w-[350px] sm:w-[490px] 2xl:w-[637px] flex-grow-0 flex-shrink-0">
          <img src="@/assets/images/home-image1.png" alt="image1">
        </div>
      </div>
      <div class="flex flex-col-reverse lg:flex-row justify-between items-center lg:space-x-[60px] xl:space-x-[120px]">
        <div class="w-[350px] sm:w-[490px] 2xl:w-[637px] flex-shrink md:flex-grow-0  md:flex-shrink-0">
          <img src="@/assets/images/home-image2.png" alt="image2">
        </div>
        <div class="text-left space-y-6 mb-[32px]">
          <h2 class="text-[22px] sm:text-[30px] md:text-[35px] xl:text-[40px] font-bold text-black uppercase">{{ t('home.vision.values') }}</h2>
          <h4 class="text-[18px] md:text-[22px] leading-[32px] text-light text-black">
            {{ t('home.vision.valuesText') }}
          </h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import petMobileImg from '@/assets/images/pet-bg-mobile.png'
import petImg from '@/assets/images/petImg.png'
import { useI18n } from 'vue-i18n'
import { useIsMobile } from '@/composables/Mobile'

const { isMobile } = useIsMobile()
const { t } = useI18n()
</script>
